/*
 * Copyright (c) 2020. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <https://veneliniliev.com>
 */

export enum PymentableType {
  HOTELBOOKING = 'App\\Models\\HotelBooking',
}
